import { CenteredPageContent } from '@/components/Layouts/CenteredPageContent';
import { CardGrid } from '@/components/Molecules/CardGrid/CardGrid';
import { Stack } from '@/components/Molecules/Stack/Stack';
import { ScheduledEvent } from '@/components/Organisms/ScheduledEvent/ScheduledEvent';
import useTranslation from '@/hooks/useTranslation';
import type { IEvent } from '@/interfaces';
import classNames from '@/utils/classNames';
import { getMonthAndYearStringForLocale } from '@/utils/dateUtils';
import { useMemo } from 'react';
import styles from './ScheduledEventList.module.css';
interface IProps {
  items: IEvent[];
}
export const ScheduledEventsList = ({
  items
}: IProps) => {
  const {
    lang
  } = useTranslation();
  const itemsForMonth = useMemo(() => {
    const mappings: {
      [key: string]: IEvent[];
    } = {};
    for (const currentItem of items) {
      const itemMonth = getMonthAndYearStringForLocale(new Date(currentItem.startDate), lang);
      if (!mappings.hasOwnProperty(itemMonth)) {
        mappings[itemMonth] = [];
      }
      mappings[itemMonth].push(currentItem);
    }
    return mappings;
  }, [items]);
  return <div>
            {Object.keys(itemsForMonth).map((month, i) => <div key={month} className={classNames(styles.listItem, {
      'cds-background-flip': Boolean(i % 2)
    })}>
                    <CenteredPageContent>
                        <Stack>
                            <h2 className="cds-t-h2">{month}</h2>
                            <CardGrid>
                                {itemsForMonth[month].map(itemData => <ScheduledEvent initialHeadingLevel={3} event={itemData} key={itemData.url} boxed />)}
                            </CardGrid>
                        </Stack>
                    </CenteredPageContent>
                </div>)}
        </div>;
};